import {
  combine,
  withMemo,
  withContext,
  withCallbacks,
} from 'react-hooks-combine'
import { ServicesContext } from 'services/context'
import { withTableController } from 'shared/hooks'

import TransHistoryBeneComponent from './component'
import { createColumns } from './columns.description'

export default combine(
  withTableController({ id: 'transHistoryBene-table' }),

  withContext(
    'beneficiaryService',
    ServicesContext,
    ({ beneficiaryService }) => beneficiaryService
  ),

  withMemo('columns', () => createColumns(), []),

  withCallbacks(
    {
      loadTransHistory:
        ({ beneficiaryService }) =>
        (tableState, _table, query) => {
          const isHaveSearch = !!query?.search
          return beneficiaryService.getBeneTransHistory({
            page: tableState.page,
            size: tableState.pageSize,
            ...(isHaveSearch ? { matchNameSearch: query?.search } : {}),
            tournamentId: query?.tournamentId,
            sportType: query?.sport,
            includeZero: true,
          })
        },
      onSearch:
        ({ table }) =>
        (query) => {
          table.search(query)
        },
    },
    []
  )
)(TransHistoryBeneComponent)
